export type ErrorOrigin = 'server' | 'client';

/**
 * Critical application error that should be caught by error boundaries
 * and reported to monitoring services like New Relic
 */
export class CriticalApplicationError extends Error {
  public readonly origin: ErrorOrigin;
  public readonly timestamp: string;
  public readonly innerError?: Error;

  constructor(message: string, origin: ErrorOrigin, innerError?: Error) {
    super(message);
    this.name = 'CriticalApplicationError';
    this.origin = origin;
    this.timestamp = new Date().toISOString();
    this.innerError = innerError;

    // Maintain proper stack trace for V8 engines
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CriticalApplicationError);
    }

    // If we have an inner error, preserve its stack
    if (innerError && innerError.stack) {
      this.stack = `${this.stack}\n\nInner Error: ${innerError.stack}`;
    }
  }
}
